export enum RoutePaths {
  Root = '/',
  AssemblyTemplates = '/assembly-templates',
  Assemblies = '/assemblies',
  AssemblyTemplate = '/assembly-templates/:id',
  Assembly = '/assemblies/:id',
  Team = '/team',
  BillingSetup = '/billing-setup',
}
